import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})

export class StoreService {

  private profileImageSource = new BehaviorSubject('');
  currentProfileImage = this.profileImageSource.asObservable();
  userActivated = new Subject();
  unsubscribeRoute = new Subject();
  isTabActivated = new Subject();
  addHeaderClass = new Subject();
  updateRole = new Subject();
  previousRoute = null;
  localData:BehaviorSubject<string> = new BehaviorSubject<string>(null);
  bannerData:Subject<any>=new Subject();
  isCiscoAdminFlag=new BehaviorSubject<any>(null);
  quizData=new BehaviorSubject<any>(null);
  selectedPageNum='';
  constructor() { }

  changeProfileImage(pic) {
    this.profileImageSource.next(pic);
  }

  getPreviousRoute() {
    return this.previousRoute;
  }

  setPreviousRoute(route) {
    this.previousRoute = route;
  }
  setUserObj(data){
    console.log(data)
    this.localData.next(data);
    this.getUserObj()
  }
  getUserObj():Observable<any>{
    return this.localData.asObservable();
  }
  setCiscoAdminFlag(data:any,flag){
    this.isCiscoAdminFlag.next({isCiscoAdmin:data,createChg:flag})
  }
  getIsciscoAdminFlag():Observable<any>{
    return this.isCiscoAdminFlag.asObservable();
  }
  clearCiscoAdminVal(){
    this.isCiscoAdminFlag.next({isCiscoAdmin:''}) 
  }
  setQuizData(data){
    this.quizData.next({response:data})
  } 

  getQuizData():Observable<any>{
    return this.quizData.asObservable();
  }
  setActivityChallengePageNum(pageNo){
    this.selectedPageNum=pageNo
  }
  getActivityChallengePageNum(){
    return this.selectedPageNum;
  }
  clearActivityChallengePageNum(){
   this.selectedPageNum='';
  }
 
}
